<form #form="ngForm"
      method="post"
      novalidate>
    @if (fields) {
    <div class="p-a-10"
         id="customFormId">

        <!-- submission result -->
        <result class="block pos-relative m-b-5 p-l-10 p-t-1 p-b-1 _sign-up-form"
                [status]="status"
                duration="permanent"
                [success]="model.data.success_message"></result>
        <h5 class="h2">{{model.data.title}}</h5>
        <div class="m-t-5">
            <!-- fields -->
            @for (field of fields; track trackByFieldCid($index, field)) {
            <input-wrap class="m-t-5 block">
                @switch (field.field_type) {
                <!-- input: text -->
                @case ('text') {
                <input class="input"
                       type="text"
                       [autocomplete]="autoCompleteValue[field.label.toLowerCase()]"
                       [muiInput]="field.label"
                       name="{{field.cid}}"
                       [(ngModel)]="data[field.cid]"
                       [required]="field.required">
                }
                <!-- input: number -->
                @case ('number') {
                <input class="input"
                       type="number"
                       [muiInput]="field.label"
                       name="{{field.cid}}"
                       [(ngModel)]="data[field.cid]"
                       [required]="field.required"
                       step="1"
                       min="0">
                }
                <!-- input: email -->
                @case ('email') {
                <input class="input"
                       type="email"
                       [muiInput]="field.label"
                       name="{{field.cid}}"
                       [(ngModel)]="data[field.cid]"
                       (ngModelChange)="detectChanges()"
                       [required]="field.required"
                       validatePattern="email">
                }
                <!-- input: textarea -->
                @case ('paragraph') {
                <textarea class="textarea input"
                          [muiInput]="field.label"
                          name="{{field.cid}}"
                          [required]="field.required"
                          [(ngModel)]="data[field.cid]"></textarea>
                }
                <!-- input: select -->
                @case ('dropdown') {
                <select name="{{field.cid}}"
                        class="select"
                        [autocomplete]="autoCompleteValue[field.label.toLowerCase()]"
                        [muiInput]="field.label"
                        [(ngModel)]="data[field.cid]"
                        [required]="field.required">
                    @if (!!field.field_options.options) {
                    @for (option of field.field_options.options; track option) {
                    @if (option.label) {
                    <option [value]="option.label">{{option.label}}</option>
                    }
                    }
                    }
                </select>
                }
                <!-- input: checkbox -->
                @case ('checkboxes') {
                @for (option of field.field_options.options; track option; let i = $index) {
                <checkbox class="w-12 m-t-2"
                          [name]="field.cid"
                          [(ngModel)]="data[field.cid][i]"
                          (ngModelChange)="onCheckboxesChange(field)">
                    <span class="p2"
                          [innerHtml]="option.label">
                    </span>
                </checkbox>
                }
                @if (field.required) {
                <input-wrap>
                    <input type="hidden"
                           name="{{field.cid + 'required'}}"
                           [(ngModel)]="checkboxes[field.cid]"
                           required>
                </input-wrap>
                }
                }
                <!-- input: radio -->
                @case ('radio') {
                <radio-group [name]="field.cid"
                             [required]="field.required"
                             [(ngModel)]="data[field.cid]">
                    <p class="p1">{{field.label}}</p>
                    @for (option of field.field_options.options; track option; let i = $index) {
                    <radio class="w-12 p-l-4-s m-t-2 radio-top"
                           [value]="option.label">{{option.label}}
                    </radio>
                    }
                </radio-group>
                }
                <!-- input: subscription checkbox -->
                @case ('subscription') {
                <newsletter-checkboxes #newsletterCheckboxes
                                       class="block"
                                       [email]="email"
                                       [showBrochureCheckbox]="showBrochureCheckbox"
                                       [checkboxesMessage]="identifier === 'signup' ? true : false"
                                       source="customform"
                                       [resetSubject]="resetSubject"
                                       (optionChoosed)="validateCheckboxes($event)"
                                       [variant]="'customForm'"></newsletter-checkboxes>
                }
                }
            </input-wrap>
            }

            <!-- Turnstile widget -->
            @if (showTurnstile && turnstileSiteKey) {
            <turnstile [siteKey]="turnstileSiteKey"
                        (resolved)="onTurnstileResolved($event)" />
            }

            <!-- submit button -->
            <action [status]="status"
                    class=" button w-12 m-t-10"
                    duration="permanent"
                    (click)="submit()">{{model.data.submit_button_text || ('Send' | translate)}}</action>
        </div>
    </div>
    }
</form>